import React from "react";
// used for making the prop types of this component
import PropTypes from "prop-types";
import axios from "axios";
import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress.jsx";
// core components
import Button from "components/CustomButtons/Button.jsx";

import defaultAvatar from "assets/img/placeholder.jpg";
import api from '../../api/Api';
import AxiosMaster from '../../AxiosFactory';

class ReportUpload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            file: null,
            upload: "none",
            uploading: false,
            hitSubmit: false,
            hitimage: false,
            imagePreviewUrl: defaultAvatar,
            removeoff: true,
            uploadprogress: 0,
            imageurl: "",
            imageUrl: "",
            url: "",
            fileName: null,
            multipltFile: []
        };
        this.handleImageChange = this.handleImageChange.bind(this);
        this.handleImageSubmit = this.handleImageSubmit.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
    }

    handleImageChange(e) {
        e.preventDefault();
        this.setState({multipltFile: Array.from(e.target.files)})
        if (e.target.files.length > 1) {
            let file = Array.from(e.target.files);
            (Array.from(e.target.files)).map(item => {
                let reader = new FileReader();
                var postReport = {
                    "file_name": (new Date).getTime() + "_" + item.name.replace(/ /g, ''),
                    "type": item.type,
                    "clinic_id": this.props.clinic_id
                };
                api.uploadReport(postReport).then(json => {
                    this.setState({imagePreviewUrl: json.data.data.url}, () => {
                        const bucket = json.data.data.url.split('.amazonaws')[0].split('://')[1].split('.')[0];
                        const url = AxiosMaster.ImageUrlUpload + json.data.data.complete_url + "/" + postReport.file_name;
                        this.props.handleImageUrl(url);
                        this.setState({imageUrl: url, url: url});
                        axios.put(this.state.imagePreviewUrl, item, {headers: {'Content-Type': item.type,'User-Agent': '5c2a01a4040ca45d93c56843'}}).then(json => {
                            this.setState({upload: "success", uploading: false});
                        }).catch(err => {
                            this.setState({upload: "error", uploading: false});
                        });
                    });

                })
                reader.onloadend = () => {
                    this.setState({
                        file: item,
                        imagePreviewUrl: reader.result
                    });
                };
                reader.readAsDataURL(item);
            })
        }
        else {
            let reader = new FileReader();
            let file = e.target.files[0];
            this.setState({fileName: file.name})
            var postReport = {
                "file_name": (new Date).getTime() + "_" + file.name.replace(/ /g, ''),
                "type": file.type,
                "clinic_id": this.props.clinic_id
            };
            api.uploadReport(postReport).then(json => {
                this.setState({imagePreviewUrl: json.data.data.url}, () => {
                    const bucket = json.data.data.url.split('.amazonaws')[0].split('://')[1].split('.')[0];
                    const url = AxiosMaster.ImageUrlUpload + json.data.data.complete_url + "/" + postReport.file_name;
                    this.props.handleImageUrl(url);
                    this.setState({imageUrl: url, url: url});
                    axios.put(this.state.imagePreviewUrl, file, {headers: {'Content-Type': file.type,'User-Agent': '5c2a01a4040ca45d93c56843'}}).then(json => {
                        this.setState({upload: "success", uploading: false});
                    }).catch(err => {
                        this.setState({upload: "error", uploading: false});
                    });
                });

            });
            reader.onloadend = () => {
                this.setState({
                    file: file,
                    imagePreviewUrl: reader.result
                });
            };
            reader.readAsDataURL(file);
        }

    }

    handleImageSubmit(callback) {
        this.setState({hitSubmit: true});
        this.setState({uploading: true});
        var data = new FormData();
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }, onUploadProgress: function (progressEvent) {
                var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                this.setState({uploadprogress: percentCompleted});
            }.bind(this)
        }
        // data.append("file", this.state.file);
    }

    componentDidMount() {
        if (this.props.imageurl !== "")
            this.setState({file: this.props.imageurl, upload: "success", uploading: false, removeoff: false})
    }

    componentDidUpdate() {
        if (this.state.file !== null && this.state.hitSubmit === false) {
            this.handleImageSubmit(function (url) {
                this.props.handleImageUrl(url);
            }.bind(this));
        }
    }


    handleClick() {
        this.refs.fileInput.click();
        this.setState({upload: "none"});
        this.setState({hitSubmit: false});
        this.setState({removeoff: true});
        this.props.changeUrl(this.state.imageUrl, this.state.url)
    }

    handleRemove() {
        this.props.removeUrl(this.state.imagePreviewUrl);
        this.setState({
            file: null,
            imagePreviewUrl: defaultAvatar
        });
        this.refs.fileInput.value = null;
        this.setState({upload: "none"});
        this.setState({hitSubmit: false});
        this.setState({removeoff: false});
        var url = "";
        this.props.removeUrl(this.state.imageUrl);
    }

    render() {
        var {
            avatar,
            addButtonProps,
            changeButtonProps,
            removeButtonProps
        } = this.props;

        return (
            <div className="fileinput text-center">
                <input type="file" onChange={this.handleImageChange} ref="fileInput" multiple/>
                <div>
                    {this.state.file === null ? (
                        <Button {...addButtonProps} onClick={() => this.handleClick()}>
                            {avatar ? "Add Report" : "Select Report"}
                        </Button>
                    ) : this.state.multipltFile.length > 1 ? (this.state.multipltFile.map((item) => {
                        return <span>
                            <div className="displayInline">

                                <i style={{fontSize: '48px'}} className="fa fa-file"/>            
                                <div> 
                                    <p style={{marginTop: '15px', padding: '0 20px'}}>
                                                    {item.name}</p>
                                </div>
                    

                                {
                                    this.state.removeoff ? ( <div>
                                        <div>
                                            {this.state.uploading ? (
                                                <div><p style={{marginTop: '15px', padding: '0 20px'}}>Uploading
                                                    ... </p><CustomLinearProgress
                                                    variant="determinate"
                                                    color="rose"
                                                    value={this.state.uploadprogress}
                                                /></div>) : null}
                                        </div>
                                        <div>
                                            {this.state.upload === "success" ? (
                                                <p style={{marginTop: '15px', padding: '0 20px'}}>
                                                    Uploaded</p>) : null}
                                        </div>
                                        <div>
                                            {this.state.upload === "error" ? (
                                                <p style={{
                                                    marginTop: '15px', padding: '0 20px', color: 'red',
                                                    fontWeight: 'bold',
                                                    fontSize: '15px'
                                                }}>Upload
                                                    Error</p>) : null}
                                        </div>
                                    </div>) : null
                                }
                                {/*<Button style={{margin: '5px 20px'}}*/}
                                {/*{...changeButtonProps} onClick={() => this.handleClick()}>*/}
                                {/*Change*/}
                                {/*</Button>*/}
                                {avatar ? <br /> : null}
                                <Button style={{margin: '10px 20px', marginBottom: 20}}
                                        {...removeButtonProps}
                                        onClick={() => this.handleRemove()}>
                                <i style={{paddingRight: 5}} className="fas fa-times"/> Remove
                                </Button>
                            </div><br/>
                         </span>
                    })) : (
                        <span>
                            <div className="displayInline">
                                <i style={{fontSize: '48px'}} className="fa fa-file"/>
                                <div> 
                                    <p style={{marginTop: '15px', padding: '0 20px'}}>
                                                    {this.props.imageurl ? this.props.imageurl.split(/[/ ]+/).pop() : this.state.fileName}</p></div>
                    

                                {
                                    this.state.removeoff ? ( <div>
                                        <div>
                                            {this.state.uploading ? (
                                                <div><p style={{marginTop: '15px', padding: '0 20px'}}>Uploading
                                                    ... </p><CustomLinearProgress
                                                    variant="determinate"
                                                    color="rose"
                                                    value={this.state.uploadprogress}
                                                /></div>) : null}
                                        </div>
                                        <div>
                                            {this.state.upload === "success" ? (
                                                <p style={{marginTop: '15px', padding: '0 20px'}}>
                                                    Uploaded</p>) : null}
                                        </div>
                                        <div>
                                            {this.state.upload === "error" ? (
                                                <p style={{
                                                    marginTop: '15px', padding: '0 20px', color: 'red',
                                                    fontWeight: 'bold',
                                                    fontSize: '15px'
                                                }}>Upload
                                                    Error</p>) : null}
                                        </div>
                                    </div>) : null
                                }
                                {/*<Button style={{margin: '5px 20px'}}*/}
                                {/*{...changeButtonProps} onClick={() => this.handleClick()}>*/}
                                {/*Change*/}
                                {/*</Button>*/}
                                {avatar ? <br /> : null}
                                <Button style={{margin: '10px 20px', marginBottom: 20}}
                                        {...removeButtonProps}
                                        onClick={() => this.handleRemove()}>
                                <i style={{paddingRight: 5}} className="fas fa-times"/> Remove
                                </Button>
                            </div>
            </span>)}</div>

            </div>
        );
    }
}

ReportUpload.propTypes = {
    avatar: PropTypes.bool,
    addButtonProps: PropTypes.object,
    changeButtonProps: PropTypes.object,
    removeButtonProps: PropTypes.object
};

export default ReportUpload;



// WEBPACK FOOTER //
// ./src/components/CustomUpload/ReportUpload.jsx